module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_omnichannel_in_customer_service-d59c8eea803c118b00a75720dd2416d6.png";